import type { TPropostaSchemaInput } from '@/features/proposta/schemas'

type ResultadoPercentual = {
  completo: boolean
  excesso: boolean
  pendente: boolean
  diferenca: number
  total: number
}

export class DistribuidorPercentual {
  private readonly percentualTotal: number

  constructor(percentualTotal: number) {
    this.percentualTotal = Number.parseFloat(percentualTotal.toFixed(2))
  }

  distribuir(ids: string[]): Array<{ id: string; percentualParticipacao: number }> {
    const total = ids.length
    if (total === 0) return []

    if (this.percentualTotal === 0.01) {
      if (total === 1) {
        return [{ id: ids[0]!, percentualParticipacao: 0.01 }]
      }

      return ids.map((id, index) => ({
        id,
        percentualParticipacao: index === 0 ? 0.01 : 0,
      }))
    }

    if (this.percentualTotal < 0.01) {
      return ids.map((id) => ({
        id,
        percentualParticipacao: 0,
      }))
    }

    if (this.percentualTotal <= 0.1) {
      const participacaoIgual = Number.parseFloat((this.percentualTotal / total).toFixed(2))
      return ids.map((id) => ({
        id,
        percentualParticipacao: participacaoIgual,
      }))
    }

    const baseInicial = this.percentualTotal / total
    const base = Number.parseFloat((Math.floor(baseInicial * 100) / 100).toFixed(2))

    const percentuais = Array.from({ length: total }, () => base)
    const somaBase = percentuais.reduce((acc, n) => acc + n, 0)
    const compensacao = Number.parseFloat((this.percentualTotal - somaBase).toFixed(2))

    if (compensacao !== 0) {
      percentuais[0] = Number.parseFloat(((percentuais[0] ?? 0) + compensacao).toFixed(2))
    }

    return ids.map((id, index) => ({
      id,
      percentualParticipacao: percentuais[index] ?? 0,
    }))
  }

  static obterResumoParticipacao(
    titularPercentual: number,
    compradoresNaoTitular: TPropostaSchemaInput['detalhesDaProposta']['participacaoCompradores']['compradores'],
  ): ResultadoPercentual {
    const toCent = (v = 0) => Math.round(v * 100)
    const totalCent =
      toCent(titularPercentual) + compradoresNaoTitular.reduce((acc, c) => acc + toCent(c.percentualParticipacao), 0)
    const totalCentRestante = !titularPercentual ? 10_000 : 10_000 - totalCent

    return {
      diferenca: Math.abs(totalCentRestante / 100),
      total: totalCent / 100,
      completo: totalCentRestante === 0,
      excesso: totalCentRestante < 0,
      pendente: totalCentRestante > 0,
    }
  }
}
